<template>
  <Block class="w-1/4">
    <div class="flex flex-col w-full gap-5">
      <h1 class="text-center">My Total Loan</h1>
      <DoughnutChart
        :chartData="chartData"
        :options="chartOptions"
        :width="250"
        :height="255"
      />
      <div class="flex flex-col gap-5">
        <LoanLegend
          title="#31"
          value="15%"
          sub-title="Paid"
          color="#01608F"
        />
        <LoanLegend
          title="#46"
          value="60%"
          sub-title="Paid"
          color="#75B1FF"
        />
        <LoanLegend
          title="#89"
          value="25%"
          sub-title="Paid"
          color="#27B59B"
        />
      </div>
    </div>
  </Block>
</template>

<script>
import { DoughnutChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import Block from "../global/Block.vue";
import LoanLegend from "./LoanLegend.vue";
Chart.register(...registerables);
export default {
  name: "MyLoanChart",
  components: {
    DoughnutChart,
    Block,
    LoanLegend,
  },
  computed: {
    chartData() {
      return {
        labels: ["Total", "Paid", "Loan"],
        datasets: [
          {
            data: [60, 15, 25],
            backgroundColor: ["#75B1FF", "#01608F", "#27B59B"],
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        borderColor: "#141519",
        borderWidth: 5,
      };
    },
  },
};
</script>
